import { Controller } from "@hotwired/stimulus"

/**
 * Max Quantity Controller
 * 
 * This controller manages maximum quantity constraints for ordered items.
 * It ensures that users cannot order more items than available and updates
 * the UI accordingly when quantities change.
 * Overridden items are excluded from quantity calculations.
 */
export default class extends Controller {
  static targets = ["select"]

  declare selectTargets: HTMLSelectElement[]

  updateQuantityOptions(changedResourceItemId: number, changedOrderedItemId: number, maxQuantityOfResourceItem: number) {
    let totalQuantityOfResourceItem = 0

    //Targets that have the same resource item id but different ordered item id
    var targetsToUpdate: HTMLSelectElement[] = this.selectTargets.filter((selectTarget) => {
      const resourceItemId = Number(selectTarget.dataset.resourceItemId);
      if (resourceItemId !== changedResourceItemId) return false;

      // Skip overridden items
      if (selectTarget.dataset.overridden === "true") return false;

      const currentQuantity = Number(selectTarget.value);
      totalQuantityOfResourceItem += currentQuantity;

      return true;
    })

    const remainingMaxQuantity = maxQuantityOfResourceItem - totalQuantityOfResourceItem

    //Update select options
    targetsToUpdate.forEach((selectTarget: HTMLSelectElement) => {  
      if (changedOrderedItemId == Number(selectTarget.dataset.orderedItemId)) return
      // Skip overridden items
      if (selectTarget.dataset.overridden === "true") return

      const oldSelectedValue = Number(selectTarget.value)

      //Clear existing options
      for (let i = selectTarget.options.length - 1; i >= 0; i--) {
        selectTarget.remove(i)
      }

      //Add quantity options
      for (let i = 1; i <= oldSelectedValue + remainingMaxQuantity; i++) {
        const option = document.createElement("option")
        option.value = i.toString()
        option.text = i.toString()
        selectTarget.add(option)
      }

      //Restore selected value
      selectTarget.value = oldSelectedValue.toString()
    })
  }

  quantityChanged(event: Event) {
    const select = event.target as HTMLSelectElement

    const orderedItemId = select.dataset.orderedItemId
    const resourceItemId = select.dataset.resourceItemId
    const maxQuantityOfResourceItem = select.dataset.maxQuantity

    if (!maxQuantityOfResourceItem) return
    if (!resourceItemId) return
    if (!orderedItemId) return

    this.updateQuantityOptions(Number(resourceItemId), Number(orderedItemId), Number(maxQuantityOfResourceItem))
  }
}